import React from 'react';
import { ComponentCfgUIElementState } from '@/stores/ComponentCfgUIElementState';
import { IUiCfgContainer } from '@canvas-logic/clp-api-types';

export const ComponentsContainerCfgUIElement = ({
  childrenElements,
}: {
  childrenElements: ComponentCfgUIElementState[];
  viewElement: IUiCfgContainer;
}) => {
  const render = childrenElements.some((it) => it.isViewExist);
  if (!render) {
    return null;
  }
  return <div className="cp-components_container">{childrenElements.map((child) => child.render())}</div>;
};
